import {wsAddress} from "../../services/api";
var log = require('loglevel');
var ws = null;

//TODO(hoffmannm): Use socket.io? 
export const openWebsocket = function(userID, onOpen) {
    if ("WebSocket" in window) {
        // Let us open a web socket
        log.debug("New Websocket:", wsAddress, userID);
        ws = new WebSocket(wsAddress+userID);

        ws.onopen = function() {
            // Web Socket is connected, send data using send()
            onOpen(ws);
            // ws.send("Message to send");
            // alert("Message is sent...");
        };

         ws.onmessage = function (evt) {
             var received_msg = evt.data;
             log.debug("Websocket message", received_msg);

         };

        ws.onclose = function() {

            // websocket is closed.
            // alert("Connection is closed...");
        };
    } else {

        // The browser doesn't support WebSocket
        // alert("WebSocket NOT supported by your Browser!");
    }
}



export default ws;
